// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"347":"07baa910","413":"55dd40a3","606":"44a64451","942":"85d85b50","983":"1652cc85"}[chunkId] + ".css";
};